import type { Message } from '../i18n/t.ts';
import { languageCodeFor } from '../profile/languages.ts';
import { copyFor } from './aidErrors.ts';

/** `VocabularyItem.meaning`, as Relay types the union. */
export type MeaningInput =
  | { readonly __typename: 'Gloss'; readonly text: string; readonly language: string }
  | { readonly __typename: 'MeaningFailure'; readonly reason: string }
  | { readonly __typename: '%other' };

/**
 * What "What it means" shows — word-meanings §12.
 *
 * `set-language` only when there is no language at all: that is the one null
 * the learner can fix from here. A null despite a language is a legacy row
 * that resolves to English, and shows nothing rather than a guess.
 */
export type MeaningView =
  | { kind: 'gloss'; text: string; lang: string | undefined }
  | { kind: 'set-language' }
  | { kind: 'failed'; message: Message };

// A failure reason onto the code whose copy already says the same thing.
const CODE_FOR_REASON: Record<string, string> = {
  UNUSABLE_LANGUAGE: 'BAD_USER_INPUT',
  RATE_LIMITED: 'RATE_LIMITED',
};

export function meaningView(
  meaning: MeaningInput | null | undefined,
  nativeLanguage: string | null | undefined,
): MeaningView | null {
  if (meaning?.__typename === 'Gloss') {
    return { kind: 'gloss', text: meaning.text, lang: languageCodeFor(meaning.language) };
  }
  if (meaning) {
    const reason = meaning.__typename === 'MeaningFailure' ? meaning.reason : '';
    return { kind: 'failed', message: copyFor(CODE_FOR_REASON[reason] ?? null) };
  }
  if (!nativeLanguage) return { kind: 'set-language' };
  return null;
}
